<template>
    <SideHeader :to="'/profile'" />
    <!-- App Capsule -->
    <div id="appCapsule" class="full-height" style="padding-top: 55px;">

        <div class="listview-title mt-1">تنظیمات</div>

        <ul class="listview image-listview"> 
            <li>
                <div class="item">
                    <div class="icon-box background-TEAL text-light">
                        <ion-icon name="repeat-outline"></ion-icon>
                    </div>
                    <div class="in">
                        <div>نوتیفیکیشن</div>
                        <div class="form-check form-switch">
                            <input class="form-check-input" checked type="checkbox" id="SwitchCheckDefault5">
                            <label class="form-check-label" for="SwitchCheckDefault5"></label>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

    </div>
    <!-- * App Capsule -->
</template>
<script>
import SideHeader from '@/components/SideHeader.vue';

export default {
    components: {
        SideHeader
    },
    methods: {
        
    },
    mounted() {
        
    },
}
</script>
<style></style>